// ECDEX-3840 (slice 4): which report the candidate is looking at, for
// analytics (lib/analytics.js reads the report's account and candidate from the
// query cache to tag events). It was `navigation.currentReportIndex` in Redux,
// an index into `state.portal.reports`; it is the report's id now, so it does
// not depend on that list. A module value, not a query: nothing renders from
// it, and a cache entry nothing observes is dropped after a few minutes.
let currentReportId: string | undefined;

export const setCurrentReportId = (reportId?: string) => {
  currentReportId = reportId;
};

export const getCurrentReportId = () => currentReportId;
